export default {
  ROOM: 4,
  ROW: 3,
  RACK: 2,
  HOST: 1,
  DISK: 0
};
